import { render, staticRenderFns } from "./NovaPoshta.vue?vue&type=template&id=35a0156e&scoped=true"
import script from "./NovaPoshta.vue?vue&type=script&lang=js"
export * from "./NovaPoshta.vue?vue&type=script&lang=js"
import style0 from "./NovaPoshta.vue?vue&type=style&index=0&id=35a0156e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a0156e",
  null
  
)

export default component.exports